module.exports = __webpack_public_path__ + "97ddadde1cb5e513865c39aaeb9eb7c2.png";